// src/pages/Appli/AppliAdmin/ListingClients/charts/AssosByStatutDonut.jsx

import React, { useMemo } from "react";

import {
  Cell,
  Pie,
  PieChart,
  ResponsiveContainer,
  Tooltip,
} from "recharts";

import {
  ASSOCIATION_STATUS_INDEX,
  getAssociationStatusMeta,
} from "../data/associations.data";

export function AssosByStatutDonut({
  data = [],
}) {
  const series = useMemo(() => {
    const counts = new Map();

    data.forEach((association) => {
      const status =
        association.statut_asso ||
        "Statut inconnu";

      counts.set(
        status,
        (counts.get(status) || 0) + 1,
      );
    });

    return [...counts.entries()]
      .map(([name, value]) => {
        const meta =
          getAssociationStatusMeta(name);

        return {
          name,
          value,
          color: meta.chartColor,
        };
      })
      .sort((first, second) => {
        const firstIndex =
          ASSOCIATION_STATUS_INDEX[first.name] ??
          999;

        const secondIndex =
          ASSOCIATION_STATUS_INDEX[second.name] ??
          999;

        return firstIndex - secondIndex;
      });
  }, [data]);

  const total = series.reduce(
    (sum, item) => sum + item.value,
    0,
  );

  if (!series.length) {
    return (
      <div className="flex h-64 items-center justify-center text-sm text-slate-400">
        Aucune donnée disponible
      </div>
    );
  }

  return (
    <div>
      <div className="relative h-64">
        <ResponsiveContainer
          width="100%"
          height="100%"
        >
          <PieChart>
            <Pie
              data={series}
              dataKey="value"
              nameKey="name"
              innerRadius={58}
              outerRadius={88}
              paddingAngle={2}
              stroke="transparent"
            >
              {series.map((item) => (
                <Cell
                  key={item.name}
                  fill={item.color}
                />
              ))}
            </Pie>

            <Tooltip
              formatter={(value, name) => [
                `${value} dossier${
                  value > 1 ? "s" : ""
                }`,
                name,
              ]}
            />
          </PieChart>
        </ResponsiveContainer>

        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <div className="text-center">
            <div className="text-2xl font-bold text-slate-900 dark:text-white">
              {total}
            </div>
            <div className="text-[10px] uppercase tracking-wide text-slate-400">
              dossiers
            </div>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-1.5 sm:grid-cols-2">
        {series.map((item) => (
          <div
            key={item.name}
            className="flex items-center justify-between gap-2 rounded-lg bg-slate-50 px-2.5 py-1.5 text-xs dark:bg-slate-800/60"
          >
            <div className="flex min-w-0 items-center gap-2">
              <span
                className="h-2 w-2 shrink-0 rounded-full"
                style={{
                  backgroundColor: item.color,
                }}
              />

              <span
                className="truncate text-slate-600 dark:text-slate-300"
                title={item.name}
              >
                {item.name}
              </span>
            </div>

            <span className="font-semibold text-slate-900 dark:text-white">
              {item.value}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AssosByStatutDonut;